<template>
<div>
  <div class="header">
    <div class="clearfix">
      <img class="logo" :src="oAssets + '/icode.webp'" alt="">
      <!-- <p class="menu">首页</p>
      <p class="menu">关于比赛</p>
      <p class="menu">编程平台</p>
      <p class="menu">合作伙伴</p> -->
      <p v-for="(item,index) in menuList"
        class="menu"
        :class="{highlight:item.path==$route.path}"
        :key="index"
      >
        <router-link
          tag="a"
          :to="item.path"
        >{{item.name}}</router-link>
      </p>
    </div>
  </div>
  <router-view></router-view>
</div>
</template>

<script>

export default {
  data () {
    return {
      menuList:[
        { path: "/", name: "首页" },
        { path: "/aboutOlympic", name: "关于比赛" },
        { path: "/codeResources", name: "编程平台" },
        { path: "/partners", name: "合作伙伴" },
        { path: "/joinUs", name: "我要报名" },
        { path: "/startGame", name: "开始比赛" }
      ],
    }
  },
  mounted () {
    console.log(this.$route)
  },
  watch: {
    '$route':'getPath'
  },
  methods: {
    getPath(){
      console.log(this.$route.path);
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped rel="stylesheet/scss" lang="scss">
.header{
  width: 100%;
  height: 75px;
  margin: 0 auto;
  position: fixed;
  top: 0;
  background: #fff;
  z-index: 100;
}
.header >div{
  width: 1000px;
  height: 75px;
  margin: 0 auto;
}
.header .logo{
  /* padding: 0 100px; */
  float: left;
  margin: 8px 0;
}
.header .menu a{
  font-size: 22px;
  color: #000;
  float: left;
  padding-left: 60px;
  line-height: 75px;
  text-decoration: none;
}
.header .highlight a{
  color: rgb(0, 60, 255);
}
</style>



// WEBPACK FOOTER //
// src/components/layout.vue